import { post } from "@insite/client-framework/Services/ApiService";

export const MarkAsReadFn = async (paramaters: any) => {
    const response = await post<any>("/api/v2/DashboardMessages/MarkAsRead", paramaters);
    return response;
};
